import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';

import { PageSizeSelectionComponent } from "../shared/page-size-selection.component";
import { DropdownValue } from "../shared/dropdown.model";
import { SortModel } from "../shared/sort.model";
import { ClaimsService, FilterService } from "../core/services";
import { CustomHorizontalScrollService } from "../shared/custom-horizontal-scroll.service";
import { BrandLogosSortField } from './brand-logos-sort.enum';
import { BrandLogo } from './brand-logo.model';
import { BrandLogosService } from './brand-logos.service';
import { BrandModel } from '../shared/brand.model';
import { SortService } from '../shared/sort.service';

@Component({
  moduleId: module.id,
  templateUrl: 'brand-logos.component.html'
})

export class BrandLogosComponent implements OnInit, AfterViewInit, OnDestroy {
  data: BrandLogo[];
  errorMessage: any;
  pageNumber: number = 1;
  totalCount: number;
  pageSize: number = 0;
  showOverlay: boolean = true;
  useLightClass: boolean = true;
  logoUrlSort: SortModel = new SortModel(BrandLogosSortField.LogoUrl, SortModel.ascIcon);
  heightSort: SortModel = new SortModel(BrandLogosSortField.Height, SortModel.disabledIcon);
  widthSort: SortModel = new SortModel(BrandLogosSortField.Width, SortModel.disabledIcon);
  filterLogoUrl = new FormControl();
  filterHeight = new FormControl();
  filterWidth = new FormControl();
  showAdminActionButtons: boolean = false;
  private sortField: SortModel;
  private sortDirectionAsc: boolean = true;
  private logoUrlFilter: string = '';
  private heightFilter: string = '';
  private widthFilter: string = '';
  private inXhrGetBrandLogos: any;

  selectedBrand: any;
  brandsList: Array<BrandModel> = [];
  brandId?: number;
  brandLogoId?: number;
  showBrandOverlay: boolean = false;
  brandLogoSelected: boolean = false;
  brandInfoForm: FormGroup;

  @ViewChild("pageSizeSelection") pageSizeSelectionComponent: PageSizeSelectionComponent

  constructor(private brandLogoService: BrandLogosService,
    private claimsService: ClaimsService,
    private scrollService: CustomHorizontalScrollService,
    private filterItemsService: FilterService,
    private formBuilder: FormBuilder,
    private el: ElementRef,
    private sortService: SortService) {
  }

  ngOnInit() {
    this.brandInfoForm = this.formBuilder.group({
      brandNameField: ['', []]
    }, {});
    this.sortField = this.logoUrlSort;
    this.showAdminActionButtons = this.claimsService.getUserTypeId() === 1;
    this.brandsList = this.filterItemsService.getBrands();
    this.filterLogoUrl.valueChanges
      .debounceTime(500)
      .distinctUntilChanged()
      .subscribe((filter: string) => {
        this.logoUrlFilter = filter;
        this.getBrandLogos(1);
      });

    this.filterHeight.valueChanges
      .debounceTime(500)
      .distinctUntilChanged()
      .subscribe((filter: string) => {
        this.heightFilter = filter;
        this.getBrandLogos(1);
      });

    this.filterWidth.valueChanges
      .debounceTime(500)
      .distinctUntilChanged()
      .subscribe((filter: string) => {
        this.widthFilter = filter;
        this.getBrandLogos(1);
      });
  }

  public getBrandLogos(page: number): void {
    this.showOverlay = true;
    if (this.inXhrGetBrandLogos) {
      this.inXhrGetBrandLogos.unsubscribe();
    }
    if (this.brandId != null)
      this.inXhrGetBrandLogos = this.brandLogoService.getBrandLogos(
        this.sortField.fieldId, this.sortDirectionAsc, page, this.pageSize, this.logoUrlFilter, this.heightFilter, this.widthFilter, this.brandId.toString())
        .subscribe((res: any) => {
          this.totalCount = res.json().total;
          this.pageNumber = page;
          this.data = <Array<BrandLogo>>res.json().data;
        }, error => this.errorMessage = error, () => this.onCompletedGetBrandLogos())
    else this.showOverlay = false;
  }

  private onCompletedGetBrandLogos() {
    this.showOverlay = false;
    this.toggleHorizontalScroll();
  }

  onBrandAutocompleteClicked(item) {
    let ng2Autocomplete = this.el.nativeElement.querySelectorAll("ng2-auto-complete");
    $(ng2Autocomplete).addClass('custom-autocomplete');
    //remove the selection from the previous brand and select the current brand
    let listOfBrands = $(ng2Autocomplete).find('ul li');
    let brand = this.selectedBrand;
    $(listOfBrands).each(function (i, e) {
      $(e).removeClass('selected');
      if (brand == $(e).text()) $(e).addClass('selected');
    });
  }

  onBrandValueChanged(item) {
    this.showBrandOverlay = true;
    this.brandId = item.id;
    this.getBrandLogos(1);
  }

  onBrandLogoSelection(item) {
    this.brandLogoId = item.id;
    this.brandLogoSelected = true;
  }

  autocompleListFormatter(data: any): string {
    return `${data.name}`;
  }

  onDeleteBrandLogo(event, id: number) {
    if (confirm('Are you sure you want to delete this item?')) {
      event.preventDefault();
      event.stopPropagation();
      this.brandLogoService.deleteBrandLogo(id)
        .subscribe(() =>
          this.getBrandLogos(this.pageNumber)
        );
    }
  }

  onResize(event) {
    this.toggleHorizontalScroll();
  }

  private toggleHorizontalScroll() {
    let self = this;
    setTimeout(function () {
      self.scrollService.toggleHorizontalScroll();
    }, 10);
  }

  onSortChanged(sort: SortModel) {
    let sortResult = this.sortService.toggleTableColumnSort(this.sortField, this.sortDirectionAsc, sort);
    this.sortField = sortResult.existingSortModel;
    sort = sortResult.selectedSortModel;
    this.sortDirectionAsc = sortResult.sortDiresctionAsc;

    this.getBrandLogos(1);
  }

  onPageSizeChanged(item: DropdownValue) {
    this.pageSize = item.value;
    this.pageNumber = 1;
    this.getBrandLogos(this.pageNumber);
  }

  onBrandLogoCreated() {
    this.getBrandLogos(this.pageNumber);
  }

  ngAfterViewInit() {
    this.pageSizeSelectionComponent.pageSizeValues.push(new DropdownValue(500, '500 per page'));
    this.pageSize = this.pageSizeSelectionComponent.defaultPageSizeSelection.value;
    this.getBrandLogos(1);
  }

  ngOnDestroy() {
    if (this.inXhrGetBrandLogos) {
      this.inXhrGetBrandLogos.unsubscribe();
    }
    this.scrollService.toggleHorizontalScroll(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/brand-logos/brand-logos.component.ts